import { isDate as e } from "./isDate.js";
import { toDate as o } from "./toDate.js";
function a(r) {
  if (!e(r) && typeof r != "number")
    return !1;
  const t = o(r);
  return !isNaN(Number(t));
}
export {
  a as default,
  a as isValid
};
//# sourceMappingURL=isValid.js.map
